<template>
  <div >
    <div class="img-top">
      <!--      <div class="text-title">平台简介</div>-->
      <!--			<div class="text-subtitle">解决你的临时用电需求 专注用电需求</div>-->
    </div>
      <!-- 循环渲染每一个新闻项目 -->
      <news-item
          v-for="(item, index) in newsItems"
          :key="index"
          :title="item.title"
          :subtitle="item.subtitle"
          :description="item.description"
          :images="item.images"
      />
    <div style="height: 30px;"></div>
  </div>
</template>

<script>
// 导入我们创建的 NewsItem 子组件
import NewsItem from './NewsItem.vue';

export default {
  name: 'App',
  components: {
    NewsItem
  },
  data() {
    return {
      // 从图片中提取的文本和图片路径数据
      newsItems: [
        {
          title: '长安区人民政府南村站464南村线迁改',
          subtitle: '精准保障，助力城市焕新升级',
          description: '长安区人民政府南村站464南村线迁改工程范围广、周期长、保电要求高，覆盖25处用户。现场存在拆迁资料缺失、道路受限、泥沙杂乱等难题，且需低温寒夜作业。无忧用电班组三轮勘察、精准控险，统筹50余人、25台机组，累计供电181.5时户数，克服多重困难，全程零差错完成保电，筑牢区域供电防线。',
          images: [
            // 请替换为实际的图片路径
            require('@/assets/image/pic1.png'),
            require('@/assets/image/pic2.png')
          ]
        },
        {
          title: '市第一人民医院线路迁改',
          subtitle: '科学统筹，提升供电可靠性',
          description: '仓盛站754仓焦线市政府督办工程，保电聚焦医院建设项目，改善南二环建华大街区域电力布局，无忧用电平台承担了南二环建华大街迁改供电保障任务，保电现场统筹30余人团队，协调20台柴油发电机组,保电班组坚守12小时化解各类险情，保障15户有效保电用户供电，以高效应急处置护航民生重点工程。',
          images: [
            // 请替换为实际的图片路径
            require('@/assets/image/pic3.png'),
            require('@/assets/image/pic4.png')
          ]
        }
      ]
    };
  }
};
</script>

<style>

.img-top {
  height: 2.1rem;
  background-color: #c4c4c4;
  background-image: url("../../assets/image/banner2.jpg");
  background-size: 100% 100%;
  padding: 0.59rem 0 0 2rem;
  -webkit-box-sizing: border-box;
}
</style>
